import { FC } from 'react';

import { twMerge } from 'tailwind-merge';

import { SelectIcon } from '../../../assets';
import { TPasswordRuleItem } from './types';

export const PasswordRuleItem: FC<TPasswordRuleItem> = ({
  value,
  label,
  checkValidRule,
}) => {
  const isValid = checkValidRule(value);
  return (
    <li className="flex items-center gap-2">
      <SelectIcon
        className={twMerge([
          'size-4 text-base-100 transition-colors duration-200',
          isValid && 'text-white',
        ])}
      />
      <p
        className={twMerge([
          'text-base-100 transition-colors duration-200 typography-13r',
          isValid && 'text-white',
        ])}
      >
        {label}
      </p>
    </li>
  );
};
